@let formValues = dropoffForm.value;

<app-dialog-wrapper>
  <div class="content">
    <div class="content__address">
      <div
        class="content__address-details address-details"
        [class.selected]="formValues['apt_suite']"
      >
        <div class="address-details__icon">
          <i class="icon icon-pin-outline"></i>
        </div>

        <span class="address-details__label">
          {{ formValues['apt_suite'] || 'Please, select Apt/Suite' }}
        </span>
      </div>

      <div class="content__address-add-apt-suite add-apt-suite">
        <button class="add-apt-suite__button" (click)="openAptSuiteDialog()">
          <span class="add-apt-suite__button-label">Add Apt/Suite</span>
        </button>
      </div>
    </div>

    <form [formGroup]="dropoffForm" class="content__form">
      <div class="content__form-delivery-options">
        <app-radio-card
          formControlName="delivery"
          label="Hand it to me"
          name="dropoff"
          radioValue="hand_it_to_me"
          icon="icon-delivery-service-outline"
          [subitems]="DELIVERY_HAND_OPTIONS"
        />

        <app-radio-card
          formControlName="delivery"
          label="Leave at Location"
          name="dropoff"
          radioValue="leave_at_location"
          icon="icon-delivery-location-outline"
          [subitems]="DELIVERY_LEAVE_OPTIONS"
        />
      </div>

      <div class="content__form-instructions">
        <app-textarea
          formControlName="instructions"
          label="Instructions for delivery person"
          placeholder="Example: Ring the bell"
        />
      </div>
    </form>
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button
      [size]="ButtonSize.Large"
      (buttonClick)="onConfirmInstructions()"
    >
      Confirm Instructions
    </app-button>
  </div>
</app-dialog-wrapper>
